module.exports = __webpack_public_path__ + "img/xgs_qrcode.b3a53b85.jpg";